var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSemiCircleGroupOrangeDesktop = function SvgSemiCircleGroupOrangeDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 125,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227 0c0 13.236-10.764 24-24 24s-24-10.764-24-24h48ZM149 116.48C149 82.58 176.206 55 209.648 55c33.441 0 60.647 27.58 60.647 61.48H149ZM77 54.626C77 30.11 96.65 10 121.022 10s44.021 19.919 44.021 44.626H77Z",
    fill: "#1279B4",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-17 123.826c7.297-16.256 29.843-23.332 44.993-14.151 3.317 1.99 6.192 4.529 9.73 5.97 3.538 1.441 8.066 1.212 10.646-1.638 1.875-2.211 2.096-5.413 3.759-7.845 3.98-5.971 13.488-3.653 19.344.548 5.855 4.202 12.047 9.828 19.122 8.739 8.624-1.442 12.162-11.72 14.152-20.237 1.99-8.517 5.733-18.787 14.487-19.892 13.816-1.77 19.344 20.998 33.168 22.546 6.74.778 12.71-3.98 18.238-8.067a124.264 124.264 0 0 1 19.786-11.94c8.738-4.202 21.121-6.552 26.649 1.44 1.875 2.76 2.457 6.077 3.759 9.058 3.865 8.296 13.594 12.285 22.775 12.383 9.058.115 17.902-2.653 26.862-4.422a8.748 8.748 0 0 1 4.75 0c1.326.557 2.325 1.883 3.21 2.989 3.096 4.201 6.077 8.402 9.172 12.604",
    stroke: "#F39238",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};

export default SvgSemiCircleGroupOrangeDesktop;